/**
 * @generated SignedSource<<ca36f8ea4ad3c1c6fb681fb802404cf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SquareGiftCardStatus = "ACTIVE" | "BLOCKED" | "DEACTIVATED" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type GiftCardsList_customer$data = {
  readonly allGiftCards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly balance: number;
        readonly id: string;
        readonly status: SquareGiftCardStatus;
        readonly " $fragmentSpreads": FragmentRefs<"GiftCard_squareGiftCard">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "GiftCardsList_customer";
};
export type GiftCardsList_customer$key = {
  readonly " $data"?: GiftCardsList_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GiftCardsList_customer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "active"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GiftCardsList_customer",
  "selections": [
    {
      "alias": "allGiftCards",
      "args": [
        {
          "kind": "Variable",
          "name": "active",
          "variableName": "active"
        }
      ],
      "concreteType": "SquareGiftCardConnection",
      "kind": "LinkedField",
      "name": "squareGiftCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareGiftCardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCard",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GiftCard_squareGiftCard"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "balance",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};

(node as any).hash = "38379c63c854c8ad8a2c461031293a4f";

export default node;
